module.exports = __webpack_public_path__ + "static/media/register-icon.65c4d2bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/register-icon.svg
// module id = 463
// module chunks = 0